import PropTypes from 'prop-types';
import React from 'react';
import { Redirect } from 'react-router-dom';
import SpeechRecognition from 'react-speech-recognition';

const propTypes = {
  transcript: PropTypes.string,
  resetTranscript: PropTypes.func,
  startListening: PropTypes.func,
  stopListening: PropTypes.func,
  browserSupportsSpeechRecognition: PropTypes.bool
};

const Dictaphone = ({
  setDurumNotuText,
  transcript,
  resetTranscript,
  startListening,
  stopListening,
  browserSupportsSpeechRecognition,
  listening
}) => {
  if (!browserSupportsSpeechRecognition) {
    return null;
  }

  startListening();


  // let Durum = "";
  if (listening === true) {
    if (transcript.includes('Yönlendir') || transcript.includes('yönlendir') || transcript.includes('yonlendir')) {
      stopListening();
      resetTranscript();
      return <Redirect to="/overview" />;
    }
    // Durum = "Dinleme Açık";
  } else {
    // Durum = "Dinleme Kapalı";
  }

  return (
    <div>
      {/* <MicNoneIcon onClick={resetTranscript}></MicNoneIcon> */}

      {/* (listening)
        ?
        <MicOffIcon onClick={stopListening} color="error"></MicOffIcon>
        :
        <SettingsVoiceIcon onClick={startListening} color="primary"></SettingsVoiceIcon>
      }  */}
      {/* <span>{transcript}</span>  */}
    </div>
  );
};
Dictaphone.propTypes = propTypes;
export default SpeechRecognition(Dictaphone);
